// react
import React, { Component, PropTypes } from "react"
import { connect } from "react-redux"
import DocumentTitle from "react-document-title"
// material-ui
import injectTapEventPlugin from "react-tap-event-plugin"
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider"
import Snackbar from "material-ui/Snackbar"
// app
import { getUserFromToken } from "actions/user/actions.js"
import { getCSV } from "actions/export/actions.js"
import Header from "components/common/Header"
import Spinner from "components/common/Spinner"
import { error, fetching } from "../../reducer.js"
// css
import "./flexboxgrid.min.css"
import "./application.styl"

// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin()


class Application extends Component {
    constructor(props) {
        super()

        this.export = this.export.bind(this)
    }

    export(e) {
        this.props.getCSV()

        e.preventDefault()
        return false
    }

    componentWillMount() {
        this.props.getUserFromToken()
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.filename === this.props.filename) return
        if (nextProps.filename === "") return
        window.open(nextProps.filename)
    }

    render() {
        const { error, fetching } = this.props

        return (
            <DocumentTitle title="AviationNetwork">
                <MuiThemeProvider>
                    <div className="app">
                        { fetching ? <Spinner /> : null }
                        { error ?
                            <Snackbar
                                open={ true  }
                                message={ error }
                                action="Ok"
                                onActionTouchTap={ this.props.clear }
                                onRequestClose={ this.props.clear }
                            />
                            : null
                        }
                        <Header
                            isAdmin={ this.props.isAdmin }
                            isLoggedIn={ this.props.isLoggedIn }
                            userName={ this.props.userName }
                            onExport={ this.export }
                        />

                        <div className="container">
                            { this.props.children }
                        </div>
                    </div>
                </MuiThemeProvider>
            </DocumentTitle>
        )
    }
}

Application.propTypes = {
    children: PropTypes.node.isRequired
}

const mapStateToProps = (state) => {
    return {
        error: error(state),
        fetching: fetching(state),
        filename: state.export.get("filename"),
        isAdmin: (state.user.get("admin") === 1),
        isLoggedIn: (state.user.get("id") !== 0),
        userName: state.user.get("name")
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        clear: () => dispatch({ type: "CLEAR_ERROR" }),
        getCSV: () => dispatch(getCSV()),
        getUserFromToken: () => {
            const token = sessionStorage.getItem("token")
            if (!token || token === "") return
            dispatch(getUserFromToken(token))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Application)


/** WEBPACK FOOTER **
 ** ./src/containers/Application/application.js
 **/